import NotificationsActiveIcon from "@mui/icons-material/NotificationsActiveOutlined";
import { Box, Chip, Grid, Tooltip, Typography } from "@mui/material";
import { ChannelIcon } from "../../channels/components/channel-icon";

import type { ChannelName } from "../../channels/types";
import type { MomentCardMoment } from "../types";
import type { FC } from "react";

const followUpConditionLabel = (type: string): string => {
  switch (type) {
    case "no_interaction":
      return "Communication Not Seen";
    case "link_click":
      return "Link Clicked";
    case "no_link_click":
      return "Link Not Clicked";
    case "no_survey_completion":
    default:
      return "Survey Incomplete";
  }
};

export const MomentCardFollowUp: FC<{
  moment: {
    channel: ChannelName;
    follow_up: NonNullable<MomentCardMoment["follow_up"]>;
  };
}> = ({ moment }) => (
  <Box sx={{ pt: 2, pb: 1 }}>
    <Grid size={{ xs: 12 }}>
      <Typography align="left" fontSize={12} color="rgb(180, 180, 180)" sx={{ paddingTop: 1 }}>
        Condition
      </Typography>
    </Grid>
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        mb: -1,
      }}
    >
      <Grid size={{ xs: 10 }}>
        <Box
          sx={{
            mr: 2,
            overflow: "auto",
            display: "flex",
            flexDirection: "row",
            "::-webkit-scrollbar": {
              width: "0px",
              background: "transparent",
            },
          }}
          data-testid="segment-section"
        >
          <Chip
            label={followUpConditionLabel(moment.follow_up.config.type)}
            sx={{ my: 0.5, py: 1, mr: 1, overflow: "hidden" }}
            variant="outlined"
            size="small"
          />
        </Box>
      </Grid>
      <Box sx={{ justifyContent: "right" }} data-testid="moment-card-channel">
        <ChannelIcon channel={moment.channel} fontSize="medium" />
        <Tooltip title="Follow-Up">
          <NotificationsActiveIcon color="primary" fontSize="medium" />
        </Tooltip>
      </Box>
    </Box>
  </Box>
);
